import { UserInvitation } from "./user_invitation";

export class UserInvitations extends Array<UserInvitation> {
  constructor(invitations?: UserInvitation[]) {
    super();
    if (invitations instanceof Array)
      invitations.forEach((invitation) => this.push(invitation));
  }
}
